module.exports = "/static/media/globalPayments.509c7528.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/globalPayments.png
// module id = 1806
// module chunks = 0